import gql from 'graphql-tag';

import dokkioTagFragment from './dokkioTagFragment';
import mainDisplayObjectFragment from './mainDisplayObjectFragment';

export const homeRowFragment = gql`
  fragment homeRowFragment on HomeRow {
    dokkioClass
    homeRowType
    dokkioTagID
    dokkioTag {
      ...dokkioTagFragment
    }
    integrationID
    mainDisplayObjects {
      ...mainDisplayObjectFragment
    }
  }
  ${dokkioTagFragment}
  ${mainDisplayObjectFragment}
`;
export default homeRowFragment;
